"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeValueItem = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const attribute_value_item_styles_1 = require("./attribute-value-item.styles");
const attributes_1 = require("../../../../constants/attributes");
const filtering_1 = require("../../../../utils/filtering");
const localization_1 = require("../../../../../localization");
const attributeSpecialValueToLabel = {
    [attributes_1.SpecialAttributeValue.NotApplicable]: 'NOT_APPLICABLE_SHORT',
};
const AttributeValueItemComponent = react_1.default.forwardRef(({ value, productCount, isSelectDisabled, isChecked, isCheckDisabled, isSelected, isStrategized, isChanged, isModified, showStrategizedIndicator, isMeasureUnit, isCheckHidden, onSelect, onCheck, children, onStrategize, }, ref) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const handleSelect = () => {
        if (!isSelectDisabled) {
            onSelect(value, isMeasureUnit);
        }
    };
    const isNotApplicable = (0, filtering_1.filterTextCaseInsensitive)(String(value), attributes_1.SpecialAttributeValue.NotApplicable);
    const isUnknown = value === attributes_1.SpecialAttributeValue.Unknown;
    const title = isNotApplicable ? t({ key: attributeSpecialValueToLabel[attributes_1.SpecialAttributeValue.NotApplicable] }) : value;
    const text = `${title} (${productCount})`;
    const isDisabled = isModified || isUnknown || isNotApplicable || (showStrategizedIndicator && !isStrategized);
    return (react_1.default.createElement(attribute_value_item_styles_1.StyledAttributeValueItemContainer, null, react_1.default.createElement(attribute_value_item_styles_1.StyledAttributeValueItem, { ref: ref, showStrategizedIndicator: showStrategizedIndicator, text: text, className: (0, classnames_1.default)({
            'attribute-value--disabled': isSelectDisabled,
            'attribute-value--selected': isSelected,
        }), isStrategized: isStrategized, isChecked: isChecked, isChanged: isChanged, isDisabled: isDisabled || isCheckDisabled, onCheck: !isCheckHidden && ((_e, checked) => onCheck(value, checked)), onClick: handleSelect, onStrategize: onStrategize }), (children === null || children === void 0 ? void 0 : children.length) > 0 && (react_1.default.createElement("div", { className: "nested-values-section" }, children))));
});
AttributeValueItemComponent.displayName = 'AttributeValueItemComponent';
exports.AttributeValueItem = react_1.default.memo(AttributeValueItemComponent);
exports.default = exports.AttributeValueItem;
